import script from "./ThemeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeDialog.vue?vue&type=script&setup=true&lang=js"

import "./ThemeDialog.vue?vue&type=style&index=0&id=4aa36bd7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aa36bd7"]])

export default __exports__